<template>
  <!--
    Sección de seguridad de la home. Responde a las preguntas que hace el IT de
    cualquier empresa antes de dejar entrar a Nukli: qué IA se usa, dónde viven
    los datos y cómo están protegidos. La versión larga vive en /security.
  -->
  <section class="security lp-section">
    <div class="lp-container">
      <header class="security-head">
        <div class="lp-eyebrow"><span class="lp-eyebrow__dot"></span>{{ $t('security.eyebrow') }}</div>
        <h2 class="lp-h2 lp-balance">
          {{ $t('security.title1') }}
          <span class="lp-accent-text">{{ $t('security.titleHighlight') }}</span>
        </h2>
        <p class="lp-lead security-sub lp-balance">{{ $t('security.subtitle') }}</p>
      </header>

      <!-- Diagrama del flujo de datos -->
      <security-diagram class="security-diagram"></security-diagram>

      <!-- Garantías concretas -->
      <div class="security-grid">
        <div v-for="(card, i) in cards" :key="i" class="security-card">
          <div class="security-icon">
            <l-icon size="20" color="primary">{{ card.icon }}</l-icon>
          </div>
          <h4 class="security-title">{{ card.t }}</h4>
          <p class="security-desc">{{ card.d }}</p>
        </div>
      </div>

      <div class="security-more">
        <router-link class="lp-btn lp-btn--ghost" to="/security">
          <l-icon small>shield-check</l-icon>
          {{ $t('security.more') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import LIcon from '@/components/LIcon.vue';
import SecurityDiagram from './SecurityDiagram.vue';

export default {
  name: 'SecuritySection',
  components: { LIcon, SecurityDiagram },
  computed: {
    cards() {
      const items = this.$t('security.cards');
      // Emparejados por posición con security.cards del i18n:
      // cifrado · índice ciego · UE · IA bajo demanda · OAuth · auditoría.
      const icons = ['lock-keyhole', 'scan-search', 'globe', 'sparkles', 'key-round', 'scroll-text'];
      return items.map((c, i) => ({ ...c, icon: icons[i] || 'shield-check' }));
    },
  },
};
</script>

<style scoped>
.security { background: var(--lp-bg); }

.security-head {
  max-width: 680px;
  margin: 0 auto 64px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}
.security-sub { margin-top: 2px; }

.security-diagram {
  max-width: 1020px;
  margin: 0 auto;
}

.security-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.security-card {
  background: var(--lp-surface);
  border: 1px solid var(--lp-line);
  border-radius: var(--lp-radius);
  padding: 26px 24px;
  box-shadow: var(--lp-shadow-sm);
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.security-card:hover {
  border-color: var(--lp-line-strong);
  transform: translateY(-3px);
}
.security-icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--lp-accent-weak);
  margin-bottom: 18px;
}
.security-title {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--lp-ink);
  margin: 0 0 8px;
}
.security-desc {
  font-size: 0.925rem;
  line-height: 1.55;
  color: var(--lp-muted);
  margin: 0;
}

.security-more {
  margin-top: 44px;
  text-align: center;
}

@media (max-width: 959px) {
  .security-head { margin-bottom: 48px; }
  .security-grid { grid-template-columns: repeat(2, 1fr); margin-top: 44px; }
}
@media (max-width: 599px) {
  .security-grid { grid-template-columns: 1fr; }
}
</style>
